import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { FiConfiguration } from './FiConfiguration';

export class FiConfigurationResource extends FBaseService {
  public async getFiConfiguration(fiId: string): Promise<FiConfiguration> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/config/${fiId}/fi-configuration`,
    );
    const result: FiConfiguration = response.data.data;
    return result;
  }

  public async saveFiConfiguration(fiId: string, fiConfiguration: FiConfiguration): Promise<FiConfiguration> {
    const response: AxiosResponse = await this.apiClient.put(
      `/api/rcx/config/${fiId}/fi-configuration`, fiConfiguration,
    );
    const result: FiConfiguration = response.data.data;
    return result;
  }
}

export default FiConfigurationResource;
